import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { store } from './redux/app/store'
import Redirect from './Redirect'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Redirect />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)
